import { useQuery } from "react-query";
import queryKeys from "../constants/queryKeys";
import axios from "../plugins/axios";

const endpointUrl = `${process.env.REACT_APP_CASENEST_API_URL}/aithread/getassistants`;

const useAIAssistants = () =>
    useQuery([queryKeys.aiAssistants], async () => {

        let response = await axios.get(endpointUrl);
        return response.data;

    }, {
        staleTime: Infinity,
    });

export default useAIAssistants;
